import { fetchJson } from '@/util/helpers/ajax-helpers';
import { loading, completed, standardErrorHandler } from './helpers';
import { SUGGESTIONS_CLICKED, SEARCH_LOADED } from './constants';
import Onboarding from '../util/Onboarding';
import ModalSqlEditor from '../components/modals/ModalSqlEditor';
import ViewRef from '../util/ViewRef';
import SearchBox from '../components/SearchBox';
import { openModal } from './actions-modals';
import { importView } from './actions-views';

export function suggestionsClicked() {
  return (dispatch) => {
    Onboarding.suggestionsClicked();
    dispatch(completed(SUGGESTIONS_CLICKED));
  };
}

export function searchPerformed(text) {
  return (dispatch, getState) => {
    const isNewWorld = getState().datasource.newWorld;
    dispatch(loading(SEARCH_LOADED));
    fetchJson(`/searched/?query=${encodeURI(text)}`)
      .then(function (json) {
        if (json._isSql) {
          dispatch(openModal(ModalSqlEditor, { searchedSql: text }));
        } else if (json._viewRef) {
          dispatch(importView(ViewRef.build(json._viewRef).series()));
        } else if (json._activeLayers.length > 0) {
          dispatch(completed(SEARCH_LOADED, { json, isNewWorld }));
        } else {
          // show suggestions again
          SearchBox.open();
        }
      })
      .catch(standardErrorHandler(SEARCH_LOADED, dispatch));
  };
}
